import React from 'react'
import { Link } from 'react-router-dom'
import useCart from 'store/CartProvider'
import getProductUrl from 'helpers/getProductUrl'

const OrderProductList = ({ products }) => {
  const { addToCart } = useCart()

  return (
    <div className="mb-8">
      <h3 className="text-base lg:text-[17px] font-semibold mb-4 text-slate-800 flex items-center gap-2">
        <i className="fas fa-box text-citrus-red"></i>
        პროდუქტის დეტალები
      </h3>
      {products.map(item => (
        <div
          key={item.id}
          className="flex flex-col sm:flex-row items-start sm:items-center gap-4 p-4 border rounded-2xl bg-white transition-all duration-200 border-slate-200 hover:shadow-md mb-4"
        >
          <Link
            to={getProductUrl(item.slug)}
            className="w-16 h-16 rounded-xl flex items-center place-self-center justify-center font-semibold flex-shrink-0 bg-white"
          >
            <img
              src={item.image}
              alt={item.name}
              className="w-full h-full object-contain"
            />
          </Link>
          <div className="flex-1 min-w-0 w-full sm:w-auto">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
              <div className="flex-1 min-w-0">
                <Link
                  to={getProductUrl(item.slug)}
                  className="font-semibold text-[15px] mb-1 text-slate-900 leading-tight hover:text-citrus-red transition-all duration-200 line-clamp-2"
                >
                  {item.name}
                </Link>
                <div className="text-slate-400 text-[13px]">
                  ფასი: ₾{item.price} | რაოდენობა: {item.quantity}
                </div>
              </div>
              <div className="flex flex-col md:flex-row gap-2 w-full sm:w-auto">
                <button
                  className="bg-slate-50 text-citrus-red border border-slate-200 px-3 py-1.5 rounded-lg cursor-pointer text-[13px] font-medium transition-all duration-200 hover:bg-red-600 hover:text-white hover:border-red-600 w-full xs:w-auto whitespace-nowrap"
                  onClick={() => addToCart(item.sku, {}, false, true)}
                >
                  იყიდე ახლიდან
                </button>
                <Link
                  to={getProductUrl(item.slug)}
                  className="bg-slate-50 text-slate-600 border border-slate-200 px-3 py-1.5 rounded-lg cursor-pointer text-[13px] font-medium transition-all duration-200 hover:bg-slate-200 text-center w-full xs:w-auto"
                >
                  ნივთის ნახვა
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default OrderProductList
